var _rect, _rect2, _g, _rect3, _rect4, _path, _ellipse, _rect5, _ellipse2, _ellipse3, _ellipse4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallDocSkyfert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 96,
    viewBox: "0 0 136 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.2751,
    y: 81.4287,
    width: 34.425,
    height: 3.85714,
    rx: 1.92857,
    fill: "#93D8D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.375,
    y: 81.4287,
    width: 20.4,
    height: 3.85714,
    rx: 1.92857,
    fill: "#93D8D6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7234_50836)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 30,
    width: 30,
    height: 27,
    fill: "#FF9690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4648 29.9424H102.587L108.058 57.2878H80.4648V29.9424Z",
    fill: "#85CCCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.848 29.9424L105.441 57.2878H77.848V29.9424Z",
    fill: "#C9EAE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9334 27.1742H80.5316V23.7296C80.5316 22.372 81.0454 21.0143 82.0683 19.9828C83.0959 18.9466 84.4375 18.4285 85.7839 18.4285H88.6764C90.0228 18.4285 91.3691 18.9466 92.392 19.9828C93.4148 21.0191 93.9286 22.372 93.9286 23.7296V27.1742H93.9334Z",
    fill: "#FF9690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.171 55.3016C115.123 54.7835 115.042 54.2606 114.923 53.7425C114.723 52.8309 114.419 51.9626 114.038 51.147L103.02 27.6252C102.597 26.7281 101.931 25.9365 101.036 25.3608C100.142 24.7899 99.1475 24.5212 98.1628 24.5212H33.8228L27.4478 74.8752H40.8924C40.8924 68.1636 46.2873 62.7281 52.9383 62.7281C59.594 62.7281 64.9842 68.1636 64.9842 74.8752H78.6048C78.6048 68.1636 83.995 62.7281 90.6507 62.7281C97.3064 62.7281 102.697 68.1636 102.697 74.8752H115.228V56.4674C115.223 56.0836 115.204 55.695 115.171 55.3016ZM85.1606 52.7062C84.6182 52.7062 84.0806 52.4999 83.6715 52.0873C83.2576 51.67 83.0578 51.1278 83.0578 50.5857V33.2238C83.0578 32.7393 83.2386 32.2499 83.6097 31.8805C83.976 31.5159 84.4565 31.324 84.9417 31.324H95.6889C96.4643 31.324 97.2493 31.5447 97.9439 32.0052C98.6433 32.461 99.1523 33.0991 99.4615 33.8139L105.97 48.8683C106.322 49.6886 106.274 50.6625 105.751 51.4637C105.228 52.2696 104.362 52.7062 103.477 52.7062H85.1606Z",
    fill: "#E4FFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9331 64.1865C47.0767 64.1865 42.3335 68.9744 42.3335 74.88C42.3335 80.7809 47.0767 85.5687 52.9331 85.5687C58.7896 85.5687 63.5328 80.7809 63.5328 74.88C63.5328 68.9696 58.7943 64.1865 52.9331 64.1865ZM52.9331 79.2073C50.5639 79.2073 48.6419 77.2691 48.6419 74.88C48.6419 72.4909 50.5639 70.5527 52.9331 70.5527C55.3024 70.5527 57.2244 72.4909 57.2244 74.88C57.2291 77.2691 55.3071 79.2073 52.9331 79.2073Z",
    fill: "#744164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.798 64.1865C84.9416 64.1865 80.1984 68.9744 80.1984 74.88C80.1984 80.7809 84.9416 85.5687 90.798 85.5687C96.6497 85.5687 101.398 80.7809 101.398 74.88C101.398 68.9696 96.6497 64.1865 90.798 64.1865ZM90.798 79.2073C88.4288 79.2073 86.5068 77.2691 86.5068 74.88C86.5068 72.4909 88.4288 70.5527 90.798 70.5527C93.1672 70.5527 95.0892 72.4909 95.0892 74.88C95.094 77.2691 93.172 79.2073 90.798 79.2073Z",
    fill: "#744164"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7176 54.8892L27.6567 74.5394H41.1013C41.1013 67.8278 46.4963 62.3923 53.1472 62.3923C59.8029 62.3923 65.1932 67.8278 65.1932 74.5394H78.8138C78.8138 67.8278 84.204 62.3923 90.8597 62.3923C97.5154 62.3923 102.906 67.8278 102.906 74.5394H115.437V56.1316C115.432 55.7478 115.413 55.3593 115.38 54.9659C115.377 54.9403 115.375 54.9147 115.372 54.8892H29.7176Z",
    fill: "#93D8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.659 58.6405C116.659 57.1917 116.055 55.9443 115.194 55.3687V61.9124C116.055 61.3367 116.659 60.0941 116.659 58.6405Z",
    fill: "#FAD7B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.368 72.6541C117.368 73.8246 116.426 74.7745 115.265 74.7745H105.803C104.642 74.7745 103.7 73.8246 103.7 72.6541L104.566 68.1205C104.566 66.9499 105.508 66 106.669 66H116.131C117.292 66 118.234 66.9499 118.234 68.1205L117.368 72.6541Z",
    fill: "#AC729A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0433 72.6538C37.0433 73.8243 36.1013 74.7742 34.9405 74.7742H25.4779C24.3171 74.7742 23.3751 73.8243 23.3751 72.6538L24.0126 68.1201C24.0126 66.9495 24.9546 65.9996 26.1154 65.9996H35.578C36.7388 65.9996 37.6808 66.9495 37.6808 68.1201L37.0433 72.6538Z",
    fill: "#AC729A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 38.5,
    r: 6.5,
    fill: "#F8F1FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 35,
    width: 2,
    height: 7,
    fill: "#FF9690"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 37.5,
    width: 2,
    height: 7,
    transform: "rotate(90 51 37.5)",
    fill: "#FF9690"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.56074,
    height: 6.40185,
    rx: 1.28037,
    transform: "matrix(0.704142 -0.710059 0.704142 0.710059 75.6499 12.5325)",
    fill: "#FF9690"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.4558,
    y: 8.1106,
    width: 2.55,
    height: 6.42857,
    rx: 1.275,
    fill: "#FF9690"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.9 9.42864C113.9 12.269 109.048 14.5715 103.063 14.5715C97.0772 14.5715 92.2251 12.269 92.2251 9.42864C92.2251 6.58832 93.8897 6.21436 99.8751 6.21436C105.86 6.21436 113.9 6.58832 113.9 9.42864Z",
    fill: "#F8F1FC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.0503,
    cy: 7.5,
    rx: 6.37501,
    ry: 4.5,
    fill: "#F8F1FC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.56074,
    height: 6.40185,
    rx: 1.28037,
    transform: "matrix(-0.704142 -0.710059 -0.704142 0.710059 99.811 12.5325)",
    fill: "#FF9690"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.3251,
    cy: 17.7857,
    rx: 11.475,
    ry: 5.78571,
    fill: "#F8F1FC"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.3,
    cy: 10.7143,
    rx: 15.3,
    ry: 7.71429,
    fill: "#F8F1FC"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.425,
    cy: 10.7143,
    rx: 11.475,
    ry: 7.71429,
    fill: "#F8F1FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7234_50836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.6251,
    height: 78.4286,
    fill: "white",
    transform: "translate(23.375 14.5713)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallDocSkyfert);
export default __webpack_public_path__ + "static/media/call_doc_skyfert.0a390e415584ff7390b76f3b6c8c47b1.svg";
export { ForwardRef as ReactComponent };